import React, { useContext } from "react"
import { Link as GatsbyLink } from "gatsby"
import { handleMenuLinkClick } from "../../../handlers"
import { DrawerContext } from "../../../contexts"
import { Link } from "@chakra-ui/react"

export default function MenuItem({ url, label, children }) {
  const { onClose } = useContext(DrawerContext)

  return (
    <Link
      as={GatsbyLink}
      to={url}
      onClick={event => {
        handleMenuLinkClick(url, event)
        onClose()
      }}
      justifyContent="flex-start"
      textDecoration="none"
      alignItems="center"
      fontWeight="normal"
      color="gray.300"
      display="flex"
      size="lg"
      w="100%"
      px={4}
      py={2}
    >
      {children}
      {label}
    </Link>
  )
}
